import React from "react";
import BottomNavigation, {
  BottomNavigationAction
} from "material-ui/BottomNavigation";
import { Button, Paper, Checkbox } from "material-ui";
import { FormControlLabel } from "material-ui/Form";
import { withStyles } from "material-ui/styles";
import CTooltips from "uis/CTooltips";
import ErrorMessage from "components/ErrorMessage";

import storage from "utils/storage";
import Container from "../BaseWord/Container";
import QuestionSettingPanel from "./QuestionSettingPanel";

const styles = () => ({
  container: {
    padding: 20,
    margin: "20px auto",
    width: 1100,
    position: "relative"
  },
  header: {
    display: "flex"
  },
  title: {
    margin: 0,
    flex: 1,
    color: "#575962"
  },
  main: {
    padding: 20,
    marginBottom: 10
  },
  subTitle: {
    color: "#575962",
    display: "inline-block",
    width: 180,
    marginRight: 50,
    fontSize: "1.4rem"
  },
  buttons: {
    position: "absolute",
    right: 40,
    left: 40,
    bottom: 20
  },
  clear: {
    clear: "both"
  },
  cancelBtn: {
    marginRight: 10
  },
  actionBtn: {
    marginRight: 10,
    width: 225
  },
  errorMessage: {
    fontSize: ".9rem",
    marginBottom: 10
  },
  tooltip: {
    width: 360
  },
  button: {
    cursor: "pointer",
    border: 0,
    display: "inline-flex",
    outline: "none",
    position: "relative",
    userSelect: "none",
    alignItems: "center",
    verticalAlign: "middle",
    textDecoration: "none",
    justifyContent: "center",
    WebkitAppearance: "none",
    WebkitTapHighlightColor: "transparent",

    padding: "8px 16px",
    minWidth: 88,
    fontSize: "1rem",
    boxSizing: "border-box",
    minHeight: 36,
    transition:
      "background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    lineHeight: "1.4em",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 500,
    borderRadius: 2,
    textTransform: "uppercase",

    color: "#f4f5f8",
    boxShadow:
      "0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12)",
    backgroundColor: "#4A3E92",

    "&:hover": {
      backgroundColor: "rgba(74, 62, 146, 0.7)",
      textDecoration: "none"
    },
    "$:active": {
      boxShadow:
        "0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12)"
    }
  },
  buttonDisabled: {
    border: 0,
    display: "inline-flex",
    outline: "none",
    position: "relative",
    userSelect: "none",
    alignItems: "center",
    verticalAlign: "middle",
    textDecoration: "none",
    justifyContent: "center",
    WebkitAppearance: "none",
    WebkitTapHighlightColor: "transparent",

    padding: "8px 16px",
    minWidth: 88,
    fontSize: "1rem",
    boxSizing: "border-box",
    minHeight: 36,
    transition:
      "background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    lineHeight: "1.4em",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 500,
    borderRadius: 2,
    textTransform: "uppercase",

    cursor: "default",
    pointerEvents: "none",
    color: "rgba(0, 0, 0, 0.26)",
    boxShadow: "none",
    backgroundColor: "rgba(0, 0, 0, 0.12)"
  }
});

class Additions extends React.Component {
  componentWillMount() {
    if (storage.isReloaded()) {
      storage.removeReloaded();
      if (this.isNew()) {
        this.props.history.go(-3);
      }
    }
    if (this.isNew()) {
      if (!this.props.additions.init) this.props.init();
    } else {
      this.props.fetchSurveyDetail();
    }
    window.scroll(0, 0);
    window.addEventListener("beforeunload", this.showReloadAlert);
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.showReloadAlert);
  }

  showReloadAlert(e) {
    storage.setReloaded();
    e.returnValue = "行った変更が保存されない可能性があります。";
  }

  naviStyle(localeNo) {
    return this.props.additions.localeNo === localeNo &&
      this.props.additions.isEdit
      ? { color: "#fff", backgroundColor: "#26a69a" }
      : { color: "#333", backgroundColor: "transparent" };
  }

  isNew() {
    const { pathname } = window.location;
    return pathname.indexOf("/create_survey/") > -1;
  }
  render() {
    const {
      classes,
      additions,
      openPreviewModal,
      baseInfo,
      errors
    } = this.props;
    return (
      <Paper className={classes.container}>
        <div className={classes.header}>
          <h2 className={classes.title}>
            アンケート{this.isNew() ? "登録" : "更新"}
          </h2>
        </div>

        <div className={classes.main}>
          <ErrorMessage messages={errors} className={classes.errorMessage} />
          <div>
            <h3 className={classes.subTitle}>追加設問</h3>
            <FormControlLabel
              control={
                <Checkbox
                  checked={additions.isEdit}
                  classes={{
                    checked: classes.checked
                  }}
                  value="check"
                  onChange={this.props.checked}
                  disabled={parseInt(baseInfo.additionLimit, 10) === 0}
                />
              }
              label="設定を行う"
            />
            <div style={{ float: "right" }}>
              <CTooltips
                title="追加設問の設定を全て編集前の状態に戻します。"
                placement="bottom-end"
                light="true"
                classes={{
                  tooltip: classes.tooltip,
                  button: additions.isEdit
                    ? classes.button
                    : classes.buttonDisabled
                }}
                style={{ float: "right" }}
                button="true"
                onClick={() => this.props.discard(baseInfo)}
                disabled={!additions.isEdit}
              >
                <div style={{ marginRight: 5, height: 20 }}>編集前に戻す</div>
              </CTooltips>
            </div>
          </div>
          <Paper style={{ marginBottom: 20, height: 500 }}>
            {/* 言語タブ */}
            <div>
              <BottomNavigation
                style={{ justifyContent: "left" }}
                value={additions.localeNo}
                onChange={this.props.changeLocale}
                showLabels
              >
                {baseInfo.useLocales.indexOf("ja") > -1 && (
                  <BottomNavigationAction
                    style={this.naviStyle("ja")}
                    value="ja"
                    label="日本語"
                  />
                )}
                {baseInfo.useLocales.indexOf("en") > -1 && (
                  <BottomNavigationAction
                    style={this.naviStyle("en")}
                    value="en"
                    label="英語"
                  />
                )}
                {baseInfo.useLocales.indexOf("zh") > -1 && (
                  <BottomNavigationAction
                    style={this.naviStyle("zh")}
                    value="zh"
                    label="中国語"
                  />
                )}
                {baseInfo.useLocales.indexOf("vi") > -1 && (
                  <BottomNavigationAction
                    style={this.naviStyle("vi")}
                    value="vi"
                    label="ベトナム語"
                  />
                )}
              </BottomNavigation>
            </div>

            <div style={{ height: 477 }}>
              <div
                style={{
                  padding: 20,
                  display: "flex",
                  height: "100%",
                  boxSizing: "border-box"
                }}
              >
                <div
                  style={{
                    padding: 10,
                    border: "1px solid darkgrey",
                    width: 400,
                    overflowY: "scroll"
                  }}
                >
                  <Container
                    additionMode={true}
                    {...additions}
                    movable
                    showAdd
                    maxItemCount={baseInfo.additionLimit}
                    addNewItem={this.props.addNewItem}
                    changeItemOrder={this.props.changeItemOrder}
                    selectItem={this.props.selectItem}
                  />
                </div>
                <div
                  style={{
                    width: "100%",
                    marginLeft: 10,
                    border: "1px solid darkgrey"
                  }}
                >
                  <QuestionSettingPanel
                    {...additions}
                    additionLimit={baseInfo.additionLimit}
                    openPreviewModal={openPreviewModal}
                    changeItem={this.props.changeItem}
                    removeItem={this.props.removeItem}
                    addNewAnswer={this.props.addNewAnswer}
                    removeAnswer={this.props.removeAnswer}
                    changeAnswer={this.props.changeAnswer}
                    setPtReverse={this.props.setPtReverse}
                  />
                </div>
              </div>
            </div>
          </Paper>
        </div>
        <div className={classes.buttons}>
          {this.isNew() && (
            <div style={{ position: "absolute" }}>
              <Button
                style={{ froat: "left" }}
                raised
                className={classes.cancelBtn}
                onClick={() => {
                  this.props.history.go(-4);
                }}
              >
                キャンセル
              </Button>
            </div>
          )}
          <div style={{ textAlign: "center" }}>
            {this.isNew() ? (
              <div>
                <Button
                  raised
                  className={classes.actionBtn}
                  onClick={() => {
                    this.props.handlePrev();
                  }}
                >
                  前（基本設問文言設定）へ
                </Button>
                <Button
                  raised
                  className={classes.actionBtn}
                  onClick={() => {
                    this.props.handleRegist({
                      survey: this.props.survey,
                      additions: this.props.additions,
                      selectAttr: this.props.selectAttr,
                      baseWord: this.props.baseWord,
                      baseInfo: this.props.baseInfo,
                      alertDays: this.props.alertDays,
                      isChecked: this.props.isChecked,
                      isMailSendToEmployee: this.props.isMailSendToEmployee
                    });
                  }}
                >
                  登録
                </Button>
              </div>
            ) : (
              <div>
                <Button
                  style={{ froat: "left" }}
                  raised
                  className={classes.cancelBtn}
                  onClick={() => {
                    this.props.history.goBack();
                  }}
                >
                  キャンセル
                </Button>
                <Button
                  raised
                  onClick={() => {
                    this.props.handleUpdate({
                      survey: this.props.survey,
                      baseInfo: this.props.baseInfo,
                      additions: this.props.additions
                    });
                  }}
                >
                  更新
                </Button>
              </div>
            )}
          </div>
        </div>
      </Paper>
    );
  }
}

export default withStyles(styles)(Additions);



// WEBPACK FOOTER //
// ./src/components/CreateSurvey/Additions/index.jsx